/* eslint eqeqeq: 0 */
import React, { Component } from "react";
import { Row, Col } from "reactstrap";
import { getServerEndpoint } from "utils/serverEndpoint";
import SvgIcon from "react-icons-kit";
import { plus } from "react-icons-kit/icomoon/plus";
import "./uploadbutton.css";
import noImage from "images/noImage.png";
import { themeService } from "theme/service/activeTheme.service";
import { basicColors, retroColors, electricColors } from "../../../style/basic/basicColors";
import { sanitizedFilename } from "../../../utils/utils";
import { fetchStaticResource } from "../../../utils/utils";
import { languageService } from "../../../Language/language.service";
import { cross } from "react-icons-kit/icomoon/cross";
import ConfirmationDialog from "components/Common/ConfirmationDialog";
class AssetImageArea extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mainImageIndex: 0,
    };
  }

  onClick(imagename, index) {
    // console.log('image gallery click:', imagename, index);
    // make clicked image as zero index
    this.setState({ mainImageIndex: index });
  }

  render() {
    let imagesList = null;
    // console.log(this.props.imagesList)
    if (this.props.imagesList) {
      imagesList = this.props.imagesList.map((imageName, index) => {
        if (index !== this.state.mainImageIndex) {
          return (
            <div style={{ display: "inline-block", width: "30%", margin: "0 3% 0 0", cursor: "pointer" }} key={index}>
              <ImageMainComp
                imageName={imageName}
                borderStyle={"0px solid var(--first)"}
                width={"100%"}
                height={"100%"}
                onClick={() => {
                  this.onClick(imageName, index);
                }}
              />
            </div>
          );
        }
      });
    }

    return (
      <div>
        <Row>
          <Col md={12}>
            <ImageMainComp
              imageName={this.props.imagesList[this.state.mainImageIndex]}
              imageIndex={this.state.mainImageIndex}
              onClick={() => {
                if (this.props.imagesList.length > 0) this.props.showImgaeSlider(this.state.mainImageIndex);
              }}
              showDelete={this.props.allowDelete && this.props.imagesList.length > 0}
              onDelete={() => {
                if (this.props.onDeleteImage) {
                  this.setState({ mainImageIndex: 0 });
                  this.props.onDeleteImage(this.props.imagesList[this.state.mainImageIndex], this.state.mainImageIndex);
                }
              }}
            />
          </Col>
        </Row>
        <Row>
          <Col md={10}>
            <div
              className="scrollbarHor"
              style={{ overflow: "auto", whiteSpace: "nowrap", padding: "10px 0px 5px 0px", minHeight: "110px" }}
            >
              {imagesList}
            </div>
          </Col>
          {this.props.acctionBtn && (
            <Col md={2} style={{ padding: "0px" }}>
              <div
                style={themeService({
                  default: { padding: "25px 0px", margin: "auto", width: "50%", color: "var(--first)" },
                  retro: { padding: "25px 0px", margin: "auto", width: "50%", color: "var(--second)" },
                  electric: { padding: "25px 0px", margin: "auto", width: "50%", color: electricColors.second },
                })}
              >
                {/* <div className="upload-btn-wrapper">
                          <SvgIcon icon={plus} size={20} />

                          <input type="file" name="myfile" accept="image/*" onChange={this.props.addImage} />
                        </div> */}
                <span style={{ cursor: "pointer" }}>
                  <SvgIcon icon={plus} size={20} onClick={this.props.showImageGallery} />
                </span>
              </div>
            </Col>
          )}
        </Row>
      </div>
    );
  }
}

export default AssetImageArea;

class ImageMainComp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      imageSrc: noImage,
      confirmationDialog: false,
    };
  }

  componentDidMount() {
    this.loadImage();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.imageName !== this.props.imageName) {
      this.loadImage();
    }
  }

  async loadImage() {
    if (!this.props.imageName) {
      this.setState({ imageSrc: noImage });
      return;
    }
    const currentImageName = this.props.imageName;
    try {
      let path = getServerEndpoint() + "assetImages/" + sanitizedFilename(this.props.imageName);
      const imageToDisplay = await fetchStaticResource(path);
      if (currentImageName === this.props.imageName) {
        this.setState({ imageSrc: imageToDisplay });
      }
    } catch (error) {
      console.error("Error loading image:", error);
      this.setState({ imageSrc: noImage });
    }
  }

  handleConfirmation = (shouldDelete) => {
    if (shouldDelete && this.props.onDelete) {
      this.props.onDelete();
    }
    this.setState({ confirmationDialog: false });
  };

  render() {
    return (
      <div style={{ width: this.props.width ? "100%" : "100%", position: "relative" }}>
        <img
          style={{
            width: this.props.width ? "inherit" : "100%",
            height: this.props.height ? "inherit" : "220px",
            objectFit: "contain",
            border: themeService({
              default: {
                ...(this.props.borderStyle ? this.props.borderStyle : "3px solid var(--first)"),
              },
              retro: {},
              electric: {},
            }),
            borderRadius: "5px",
            background: "white",
          }}
          src={this.state.imageSrc}
          alt="img"
          onClick={this.props.onClick}
        />
        {this.props.showDelete && (
          <React.Fragment>
            <div style={{ position: "absolute", top: "10px", right: "10px" }}>
              <div
                style={{
                  width: "32px",
                  height: "32px",
                  background: "white",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  this.setState({ confirmationDialog: true });
                }}
              >
                <SvgIcon
                  icon={cross}
                  size={18}
                  style={{
                    color: "#840F0F",
                  }}
                />
              </div>
            </div>

            <ConfirmationDialog
              modal={this.state.confirmationDialog}
              toggle={() => this.setState({ confirmationDialog: false })}
              handleResponse={this.handleConfirmation}
              confirmationMessage={`${languageService("Are you sure you want to remove: ")} ${this.props.imageName}?`}
              headerText={languageService("Confirm Removal")}
            />
          </React.Fragment>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/LampAssets/AddAsset/AssetImageArea.jsx